if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        document.removeEventListener('keydown', this.navKeys);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.setupNav();
      }

      // Prev/next arrows + arrow keys so images can be browsed without closing the zoom.
      setupNav() {
        const dialog = this.querySelector('[role="dialog"]');
        if (!dialog) return;
        if (!this.querySelector('.product-media-modal__nav')) {
          [['prev', 'Previous image', 'M10 3L5 8l5 5'], ['next', 'Next image', 'M6 3l5 5-5 5']].forEach(
            ([dir, label, path]) => {
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = `product-media-modal__nav product-media-modal__nav--${dir}`;
              btn.setAttribute('aria-label', label);
              btn.innerHTML = `<svg viewBox="0 0 16 16" width="20" height="20" aria-hidden="true"><path d="${path}" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
              btn.addEventListener('click', () => this.step(dir === 'next' ? 1 : -1));
              dialog.appendChild(btn);
            }
          );
        }
        this.navKeys = this.navKeys || ((e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            this.step(1);
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            this.step(-1);
          }
        });
        document.addEventListener('keydown', this.navKeys);
      }

      step(delta) {
        const items = Array.from(this.querySelectorAll('[role="document"] > [data-media-id]'));
        if (items.length < 2) return;
        const current = items.findIndex((el) => el.classList.contains('active'));
        const next = items[(Math.max(current, 0) + delta + items.length) % items.length];
        items.forEach((el) => el.classList.toggle('active', el === next));
        next.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
